import toastMessage from "../../utils/toastMessage";
import language from "../../language";
import formatDropdownData from "../../utils/formatDropdownData";
import axios from "axios";
import { getStorage } from "../../utils/storage";
import api from "../../utils/api";

export const getServiceAccounts = async (lng = "english", params) => {
  const { listType } = params || {};
  let user = await getStorage();

  try {
    let headers = {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: "Bearer " + user.accessToken,
    };

    const options = {
      method: "GET",
      url: `${api("core")}/service/accounts`,
      data: null, //force axios send headers content type
      headers,
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "appName", "id");
    }

    return data.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_service_account);
  }
};

export const getSingleServiceAccount = async (lng = "english", params) => {
  const { listType, serviceAccountId } = params || {};
  let user = await getStorage();

  try {
    let headers = {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: "Bearer " + user.accessToken,
    };

    const options = {
      method: "GET",
      url: `${api("core")}/service/account`,
      data: null, //force axios send headers content type,
      params: {
        serviceAccountId,
      },
      headers,
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "clientId", "id");
    }

    return data.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_service_account);
  }
};

export const getAllCoreIntegrationServices = async (
  lng = "english",
  params
) => {
  const { listType, serviceAccountId } = params || {};
  let user = await getStorage();

  try {
    let headers = {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: "Bearer " + user.accessToken,
    };

    const options = {
      method: "GET",
      url: `${api("core")}/integration/service/active`,
      data: null, //force axios send headers content type,
      headers,
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "service", "id");
    }

    return data.data;
  } catch (error) {
    toastMessage(
      "error",
      language[lng].unable_to_fetch_core_integration_service
    );
  }
};
